import React, { Fragment } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLanguage } from '../../context/LanugageContext';
import { heroTranslations } from '../../translations/hero'

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated',
    easing: 'ease-in-out-cubic',
    duration: 2000
});

const Hero = () => {
    const { lang } = useLanguage();
    const tr = heroTranslations[lang];

    return (
        <Fragment>
            <div className="hero">
                <div className="hero-text hero-1">
                    <h1>
                        <span data-aos="fade-right" className="animated">{tr.line1}</span>
                        <span data-aos="fade-right" className="red animated">.</span>
                        <br className="break" />
                        <span data-aos="fade-right" data-aos-delay="300" className="animated">{tr.line2}</span>
                        <span data-aos="fade-right" data-aos-delay="300" className="red animated">.</span>
                        <br className="break" />
                        <span data-aos="fade-right" data-aos-delay="550" className="animated">{tr.line3}</span>
                        <span data-aos="fade-right" data-aos-delay="550" className="red animated">.</span>
                    </h1>
                </div>
            </div>

            <div className="separator" data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-out">
                <p>
                    <span className="red">{tr.quote1start}</span>{tr.quote1mid}
                </p>
                <p>
                    <span className="red">{tr.quote2start}</span>{tr.quote2mid}
                    <span className="red">{tr.quote2sail}</span>{tr.quote2sailEnd}
                    <span className="red">{tr.quote2catch}</span>{tr.quote2catchEnd}
                </p>
            </div>
        </Fragment>
    );
};

export default Hero;